import cn from 'classnames';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { ContentCardGroupProps } from './ContentCard.type';
import styles from './contentcard.module.scss';

export function ContentCardGroupGrid({
    children,
    cardCount,
    theme,
    rowType,
}: ContentCardGroupProps): React.JSX.Element {
    const nonFeaturedCardCount = theme === 'featuredcard' ? Math.min(cardCount - 1, 1) : cardCount;

    const rowTypeToHorizontalColumns: Record<string, number> = {
        'Two per row': 2,
        'Three per row': 3,
        'Four per row': 4,
    };

    const mobileColumnCountMap: Record<string, number> = {
        featuredcard: 1,
        _default: nonFeaturedCardCount === 1 ? 1 : 2,
    };

    const desktopColumnCountMap: Record<string, number> = {
        horizontal: rowType === 'One per row' ? 1 : Math.min(nonFeaturedCardCount, 2),
        vertical: rowTypeToHorizontalColumns[rowType || ''] ?? Math.min(nonFeaturedCardCount, 4),
        featuredcard: 1,
        _default: nonFeaturedCardCount,
    };

    const mobileColumns = mobileColumnCountMap[theme || ''] || mobileColumnCountMap._default;
    const desktopColumns = desktopColumnCountMap[theme || ''] || desktopColumnCountMap._default;

    const isHorizontalSingleColumn = theme === 'horizontal' && rowType === 'One per row';

    const style = {
        '--mobileColumnsCount': mobileColumns,
        '--desktopColumnsCount': desktopColumns,
        '--justifyItem': nonFeaturedCardCount === 1 ? 'center' : 'normal',
    } as React.CSSProperties;

    const contentWrapperClassNames = cn(styles.group, styles[`${theme}Group`], {
        [styles.horizontalSingleColumn]: isHorizontalSingleColumn,
        [styles.noGridSpacing]: !isHorizontalSingleColumn,
    });

    const groupGridwrapperClassNames = cn(styles.groupGridWrapper, {
        [styles.noGridSpacing]: !isHorizontalSingleColumn,
    });

    return (
        <Grid container noPadding className={groupGridwrapperClassNames}>
            <Grid
                col={{ lg: isHorizontalSingleColumn ? 10 : 12 }}
                start={{ lg: isHorizontalSingleColumn ? 2 : 1 }}
                noPadding
            >
                <div className={contentWrapperClassNames} style={style}>
                    {children}
                </div>
            </Grid>
        </Grid>
    );
}
